/**
 * @generated SignedSource<<e2a8531ddccd9346459e6bfc99628df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraTimeFormat = "DAYS" | "HOURS" | "PRETTY" | "%future added value";
export type JiraTimeUnit = "DAY" | "HOUR" | "MINUTE" | "WEEK" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type timeTrackingField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly originalEstimate: {
    readonly timeInSeconds: AGG$Long | null;
  } | null;
  readonly remainingEstimate: {
    readonly timeInSeconds: AGG$Long | null;
  } | null;
  readonly timeTrackingSettings: {
    readonly defaultFormat: JiraTimeFormat | null;
    readonly defaultUnit: JiraTimeUnit | null;
    readonly isJiraConfiguredTimeTrackingEnabled: boolean | null;
    readonly workingDaysPerWeek: number | null;
    readonly workingHoursPerDay: number | null;
  } | null;
  readonly " $fragmentType": "timeTrackingField_updateWorkItemFieldsActionRenderer";
};
export type timeTrackingField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: timeTrackingField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeTrackingField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "timeInSeconds"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "timeTrackingField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraTimeTrackingSettings",
      "kind": "LinkedField",
      "name": "timeTrackingSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isJiraConfiguredTimeTrackingEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "workingHoursPerDay"
        },
        {
          "kind": "ScalarField",
          "name": "workingDaysPerWeek"
        },
        {
          "kind": "ScalarField",
          "name": "defaultFormat"
        },
        {
          "kind": "ScalarField",
          "name": "defaultUnit"
        }
      ]
    },
    {
      "concreteType": "JiraEstimate",
      "kind": "LinkedField",
      "name": "originalEstimate",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraEstimate",
      "kind": "LinkedField",
      "name": "remainingEstimate",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraTimeTrackingField"
};
})();

(node as any).hash = "5fb522c14746070777fbe1f3fa7da46f";

export default node;
